{
  "WALLBOARD": {
    "LOADING": "Загрузка телефонных очередей...",
    "NO_QUEUES": "Телефонные очереди не найдены.",
    "NO_AGENTS": "В этой очереди нет операторов онлайн.",
    "UNKNOWN_CALLER": "Неизвестный звонящий",
    "STATUS": "Статус",
    "TIME": "Время",
    "AGENT": "Оператор",
    "EXTENSION": "Добавочный номер",
    "READY": "Готовые операторы",
    "ON_CALL": "Операторы на линии",
    "PAUSED": "Операторы на перерыве",
    "WAITING": "Звонки в ожидании",
    "MISSED_CALLS": "Пропущенные звонки",
    "HANDLED_CALLS": "Обработанные входящие звонки",
    "OUTBOUND_CALLS": "Обработанные исходящие звонки",
    "AVAILABILITY": "Доступность",
    "AVAILABILITY_TOOLTIP": "Процент входящих звонков, принятых операторами (звонки, на которые ответили)",
    "AGENTS_COUNT": "({onCall} на линии / {total} всего)",
    "NO_AVAILABLE": "(никого нет онлайн)",
    "WAITING_CALLERS_COUNT": "{count} в ожидании",
    "CALLER": "Звонящий",
    "NUMBER": "Номер",
    "WAIT_TIME": "Время ожидания",
    "ACTION": "Действие",
    "PICKUP_CALL": "Принять",
    "PICKUP_SUCCESS": "Запрос на приём звонка отправлен.",
    "PICKUP_ERROR": "Не удалось принять звонок. Попробуйте ещё раз.",
    "PICKUP_DISABLED_TOOLTIP": "Вы не можете принять звонок, находясь на другом звонке или офлайн.",
    "CHAT_STATUS": {
      "NO_ACCESS": "Нет чата"
    },
    "PHONE_STATUS": {
      "NO_ACCESS": "Нет телефона"
    }
  }
}
